// // src/pages/quotations/CreateQuotation.jsx   (note: lowercase folder name)

// // import React, { useState, useEffect } from "react";
// // import {
// //   Box,
// //   Paper,
// //   Typography,
// //   TextField,
// //   Button,
// //   IconButton,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Divider,
// //   Alert,
// //   CircularProgress,
// //   Chip,
// //   Stack
// // } from "@mui/material";
// // import { Add, Delete, AttachFile, Save, ArrowBack } from "@mui/icons-material";
// // import { useParams, useNavigate } from "react-router-dom";
// // import axios from "axios";

// // const API_URL = "http://api.onedesk.digital/api";

// // export default function CreateQuotation() {
// //   const { leadId } = useParams();
// //   const navigate = useNavigate();

// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);
// //   const [lead, setLead] = useState(null);
// //   const [success, setSuccess] = useState("");

// //   const [items, setItems] = useState([
// //     { item_name: "", description: "", qty: 1, unit: "Nos", rate: 0 }
// //   ]);

// //   const [formData, setFormData] = useState({
// //     validity_days: 15,
// //     delivery_days: 45,
// //     terms_conditions: `1. Prices are inclusive of GST @18%\n2. 50% Advance, 40% on material delivery, 10% on completion\n3. Validity: 15 days from date of quotation\n4. Delivery: 45 days from advance receipt`,
// //     tax_rate: 18
// //   });

// //   const [attachments, setAttachments] = useState([]);

// //   useEffect(() => {
// //     fetchLead();
// //   }, [leadId]);

// //   const fetchLead = async () => {
// //     try {
// //       const res = await axios.get(`${API_URL}/leads/${leadId}`);
// //       setLead(res.data.lead);
// //     } catch (err) {
// //       alert("Failed to load lead");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const addItem = () => {
// //     setItems([...items, { item_name: "", description: "", qty: 1, unit: "Nos", rate: 0 }]);
// //   };

// //   const removeItem = (index) => {
// //     setItems(items.filter((_, i) => i !== index));
// //   };

// //   const updateItem = (index, field, value) => {
// //     const updated = [...items];
// //     updated[index][field] = value;
// //     if (field === "qty" || field === "rate") {
// //       updated[index][field] = parseFloat(value) || 0;
// //     }
// //     setItems(updated);
// //   };

// //   const handleAttachment = (e) => {
// //     const files = Array.from(e.target.files);
// //     setAttachments(prev => [...prev, ...files]);
// //   };

// //   const removeAttachment = (index) => {
// //     setAttachments(attachments.filter((_, i) => i !== index));
// //   };

// //   // FIXED: Clean calculation
// //   const calculateTotals = () => {
// //     const subtotal = items.reduce((sum, item) => sum + item.qty * item.rate, 0);
// //     const tax = subtotal * (formData.tax_rate / 100);
// //     const grand = subtotal + tax;
// //     return { subtotal, tax, grand };
// //   };

// //   const { subtotal, tax, grand } = calculateTotals();

// //   const handleSubmit = async () => {
// //     if (items.some(i => !i.item_name.trim() || i.rate <= 0)) {
// //       alert("Please fill all item names and valid rates");
// //       return;
// //     }

// //     setSaving(true);
// //     setSuccess("");

// //     const payload = new FormData();
// //     payload.append("lead_id", leadId);
// //     payload.append("items", JSON.stringify(items.map(i => ({
// //       item_name: i.item_name.trim(),
// //       description: i.description || "",
// //       qty: i.qty,
// //       unit: i.unit,
// //       rate: i.rate
// //     }))));
// //     payload.append("validity_days", formData.validity_days);
// //     payload.append("delivery_days", formData.delivery_days);
// //     payload.append("terms_conditions", formData.terms_conditions);
// //     payload.append("tax_rate", formData.tax_rate);

// //     attachments.forEach(file => payload.append("attachments", file));

// //     try {
// //       const res = await axios.post(`${API_URL}/quotations`, payload, {
// //         headers: { "Content-Type": "multipart/form-data" }
// //       });

// //       setSuccess(`Quotation ${res.data.quotation_no} created successfully! Grand Total: ₹${Number(res.data.grand_total).toLocaleString("en-IN")}`);
// //       setTimeout(() => navigate(`/leads/${leadId}`), 3000);
// //     } catch (err) {
// //       console.error(err);
// //       alert("Error: " + (err.response?.data?.message || err.message));
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <Box display="flex" justifyContent="center" mt={10}>
// //         <CircularProgress />
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
// //       <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
// //         Back
// //       </Button>

// //       <Paper elevation={6} sx={{ p: 4, borderRadius: 3 }}>
// //         <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
// //           Create Quotation
// //         </Typography>

// //         <Box sx={{ bgcolor: "primary.light", color: "white", p: 3, borderRadius: 2, mb: 4 }}>
// //           <Typography variant="h6">{lead?.name} • {lead?.mobile}</Typography>
// //           <Typography>{lead?.company_name || "—"} • {lead?.address || "—"}</Typography>
// //         </Box>

// //         {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}

// //         <Typography variant="h6" fontWeight="bold" gutterBottom>Line Items</Typography>

// //         <TableContainer component={Paper} elevation={3} sx={{ mb: 4 }}>
// //           <Table>
// //             <TableHead sx={{ bgcolor: "grey.200" }}>
// //               <TableRow>
// //                 <TableCell><strong>#</strong></TableCell>
// //                 <TableCell><strong>Item Name</strong></TableCell>
// //                 <TableCell><strong>Description</strong></TableCell>
// //                 <TableCell width={100}><strong>Qty</strong></TableCell>
// //                 <TableCell width={100}><strong>Unit</strong></TableCell>
// //                 <TableCell width={150}><strong>Rate (₹)</strong></TableCell>
// //                 <TableCell width={150}><strong>Amount (₹)</strong></TableCell>
// //                 <TableCell width={80}></TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {items.map((item, i) => (
// //                 <TableRow key={i}>
// //                   <TableCell>{i + 1}</TableCell>
// //                   <TableCell>
// //                     <TextField size="small" fullWidth value={item.item_name}
// //                       onChange={e => updateItem(i, "item_name", e.target.value)}
// //                       placeholder="e.g. Modular Kitchen" />
// //                   </TableCell>
// //                   <TableCell>
// //                     <TextField size="small" fullWidth value={item.description}
// //                       onChange={e => updateItem(i, "description", e.target.value)} />
// //                   </TableCell>
// //                   <TableCell>
// //                     <TextField size="small" type="number" value={item.qty}
// //                       onChange={e => updateItem(i, "qty", e.target.value)} />
// //                   </TableCell>
// //                   <TableCell>
// //                     <TextField size="small" value={item.unit}
// //                       onChange={e => updateItem(i, "unit", e.target.value)} />
// //                   </TableCell>
// //                   <TableCell>
// //                     <TextField size="small" type="number" value={item.rate}
// //                       onChange={e => updateItem(i, "rate", e.target.value)} />
// //                   </TableCell>
// //                   <TableCell>
// //                     <Typography fontWeight="bold">
// //                       ₹{(item.qty * item.rate).toLocaleString("en-IN")}
// //                     </Typography>
// //                   </TableCell>
// //                   <TableCell>
// //                     <IconButton color="error" onClick={() => removeItem(i)}>
// //                       <Delete />
// //                     </IconButton>
// //                   </TableCell>
// //                 </TableRow>
// //               ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>

// //         <Button startIcon={<Add />} variant="outlined" onClick={addItem} sx={{ mb: 4 }}>
// //           Add Item
// //         </Button>

// //         <Paper elevation={4} sx={{ p: 3, maxWidth: 420, ml: "auto", mb: 4 }}>
// //           <Stack spacing={2}>
// //             <Box display="flex" justifyContent="space-between">
// //               <Typography>Subtotal:</Typography>
// //               <Typography fontWeight="bold">₹{subtotal.toLocaleString("en-IN")}</Typography>
// //             </Box>
// //             <Box display="flex" justifyContent="space-between">
// //               <Typography>GST ({formData.tax_rate}%):</Typography>
// //               <Typography fontWeight="bold">₹{tax.toLocaleString("en-IN")}</Typography>
// //             </Box>
// //             <Divider />
// //             <Box display="flex" justifyContent="space-between">
// //               <Typography variant="h6">Grand Total:</Typography>
// //               <Typography variant="h5" color="primary" fontWeight="bold">
// //                 ₹{grand.toLocaleString("en-IN")}
// //               </Typography>
// //             </Box>
// //           </Stack>
// //         </Paper>

// //         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 3, mb: 3 }}>
// //           <TextField label="Validity (Days)" type="number" value={formData.validity_days}
// //             onChange={e => setFormData({ ...formData, validity_days: e.target.value })} />
          
// //           <TextField label="Delivery Time (Days)" type="number" value={formData.delivery_days}
// //             onChange={e => setFormData({ ...formData, delivery_days: e.target.value })} />
// //         </Box>

// //         <TextField
// //           label="Terms & Conditions"
// //           multiline
// //           rows={6}
// //           fullWidth
// //           value={formData.terms_conditions}
// //           onChange={e => setFormData({ ...formData, terms_conditions: e.target.value })}
// //           sx={{ mb: 3 }}
// //         />

// //         <Box sx={{ mb: 4 }}>
// //           <Button variant="outlined" component="label" startIcon={<AttachFile />}>
// //             Attach Files (BOQ, Design, etc.)
// //             <input type="file" hidden multiple onChange={handleAttachment} />
// //           </Button>

// //           <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 2 }}>
// //             {attachments.map((file, i) => (
// //               <Chip key={i} label={file.name} onDelete={() => removeAttachment(i)} color="primary" variant="outlined" />
// //             ))}
// //           </Stack>
// //         </Box>

// //         <Box textAlign="center">
// //           <Button
// //             variant="contained"
// //             size="large"
// //             startIcon={saving ? <CircularProgress size={20} /> : <Save />}
// //             onClick={handleSubmit}
// //             disabled={saving}
// //             sx={{ px: 8, py: 2, fontSize: "1.2rem" }}
// //           >
// //             {saving ? "Creating..." : "CREATE QUOTATION"}
// //           </Button>
// //         </Box>
// //       </Paper>
// //     </Box>
// //   );
// // }


// // src/pages/Quotation/CreateQuotation.jsx
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Divider,
//   Alert,
//   CircularProgress,
//   Chip,
//   Stack,
// } from "@mui/material";
// import {
//   Add,
//   Delete,
//   AttachFile,
//   Save,
//   ArrowBack,
// } from "@mui/icons-material";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from   "axios";
// import api from "../../utils/api.js";
// const API_URL = "http://api.onedesk.digital/api";

// export default function CreateQuotation() {
//   const { id: leadId } = useParams(); // Fixed: now correctly reads lead ID
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [lead, setLead] = useState(null);
//   const [success, setSuccess] = useState("");

//   const [items, setItems] = useState([
//     { item_name: "", description: "", qty: 1, unit: "Nos", rate: 0 },
//   ]);

//   const [formData, setFormData] = useState({
//     validity_days: 15,
//     delivery_days: 45,
//     terms_conditions: `1. Prices are inclusive of GST @18%\n2. 50% Advance, 40% on material delivery, 10% on completion\n3. Validity: 15 days from date of quotation\n4. Delivery: 45 days from advance receipt`,
//     tax_rate: 18,
//   });

//   const [attachments, setAttachments] = useState([]);

//   useEffect(() => {
//     if (leadId) fetchLead();
//   }, [leadId]);

//   const fetchLead = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(`${API_URL}/leads/${leadId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setLead(res.data.lead);
//     } catch (err) {
//       alert("Failed to load lead");
//       navigate(-1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addItem = () => {
//     setItems([...items, { item_name: "", description: "", qty: 1, unit: "Nos", rate: 0 }]);
//   };

//   const removeItem = (index) => {
//     setItems(items.filter((_, i) => i !== index));
//   };

//   const updateItem = (index, field, value) => {
//     const updated = [...items];
//     updated[index][field] = value;
//     if (field === "qty" || field === "rate") {
//       updated[index][field] = parseFloat(value) || 0;
//     }
//     setItems(updated);
//   };

//   const handleAttachment = (e) => {
//     const files = Array.from(e.target.files);
//     setAttachments((prev) => [...prev, ...files]);
//   };

//   const removeAttachment = (index) => {
//     setAttachments(attachments.filter((_, i) => i !== index));
//   };

//   const calculateTotals = () => {
//     const subtotal = items.reduce((sum, item) => sum + item.qty * item.rate, 0);
//     const tax = subtotal * (formData.tax_rate / 100);
//     const grand = subtotal + tax;
//     return { subtotal: subtotal.toFixed(2), tax: tax.toFixed(2), grand: grand.toFixed(2) };
//   };

//   const { subtotal, tax, grand } = calculateTotals();

//   const handleSubmit = async () => {
//     if (items.length === 0 || items.some((i) => !i.item_name.trim() || i.rate <= 0)) {
//       alert("Please fill all item names and valid rates");
//       return;
//     }

//     setSaving(true);
//     setSuccess("");

//     const payload = new FormData();
//     payload.append("lead_id", leadId);
//     payload.append("items", JSON.stringify(items.map(i => ({
//       item_name: i.item_name.trim(),
//       description: i.description?.trim() || "",
//       qty: i.qty,
//       unit: i.unit,
//       rate: i.rate,
//     }))));
//     payload.append("validity_days", formData.validity_days);
//     payload.append("delivery_days", formData.delivery_days);
//     payload.append("terms_conditions", formData.terms_conditions);
//     payload.append("tax_rate", formData.tax_rate);

//     attachments.forEach((file) => payload.append("attachments", file));

//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.post(`${API_URL}/quotations`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           // Let browser set Content-Type with boundary
//         },
//       });

//       setSuccess(
//         `Quotation ${res.data.quotation_no} created successfully! Grand Total: ₹${Number(
//           res.data.grand_total
//         ).toLocaleString("en-IN")}`
//       );

//       // Redirect after 3 seconds
//       setTimeout(() => {
//         navigate("/quotations");
//       }, 3000);
//     } catch (err) {
//       console.error(err);
//       alert("Error: " + (err.response?.data?.message || err.message));
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" mt={10}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
//       <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
//         Back
//       </Button>

//       <Paper elevation={6} sx={{ p: 4, borderRadius: 3 }}>
//         <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
//           Create Quotation
//         </Typography>

//         <Box sx={{ bgcolor: "primary.light", color: "white", p: 3, borderRadius: 2, mb: 4 }}>
//           <Typography variant="h6">{lead?.name} • {lead?.mobile}</Typography>
//           <Typography>
//             {lead?.company_name || "—"} • {lead?.address || "—"} • {lead?.lead_uid}
//           </Typography>
//         </Box>

//         {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}

//         <Typography variant="h6" fontWeight="bold" gutterBottom>
//           Line Items
//         </Typography>

//         <TableContainer component={Paper} elevation={3} sx={{ mb: 4 }}>
//           <Table>
//             <TableHead sx={{ bgcolor: "grey.200" }}>
//               <TableRow>
//                 <TableCell><strong>#</strong></TableCell>
//                 <TableCell><strong>Item Name</strong></TableCell>
//                 <TableCell><strong>Description</strong></TableCell>
//                 <TableCell width={100}><strong>Qty</strong></TableCell>
//                 <TableCell width={100}><strong>Unit</strong></TableCell>
//                 <TableCell width={150}><strong>Rate (₹)</strong></TableCell>
//                 <TableCell width={150}><strong>Amount (₹)</strong></TableCell>
//                 <TableCell width={80}></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {items.map((item, i) => (
//                 <TableRow key={i}>
//                   <TableCell>{i + 1}</TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       value={item.item_name}
//                       onChange={(e) => updateItem(i, "item_name", e.target.value)}
//                       placeholder="e.g. Modular Kitchen"
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       value={item.description}
//                       onChange={(e) => updateItem(i, "description", e.target.value)}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       type="number"
//                       value={item.qty}
//                       onChange={(e) => updateItem(i, "qty", e.target.value)}
//                       sx={{ width: 80 }}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       value={item.unit}
//                       onChange={(e) => updateItem(i, "unit", e.target.value)}
//                       sx={{ width: 80 }}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       type="number"
//                       value={item.rate}
//                       onChange={(e) => updateItem(i, "rate", e.target.value)}
//                       sx={{ width: 120 }}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <Typography fontWeight="bold">
//                       ₹{(item.qty * item.rate).toLocaleString("en-IN")}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>
//                     <IconButton color="error" onClick={() => removeItem(i)}>
//                       <Delete />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Button startIcon={<Add />} variant="outlined" onClick={addItem} sx={{ mb: 4 }}>
//           Add New Item
//         </Button>

//         <Paper elevation={4} sx={{ p: 3, maxWidth: 420, ml: "auto", mb: 4 }}>
//           <Stack spacing={2}>
//             <Box display="flex" justifyContent="space-between">
//               <Typography>Subtotal:</Typography>
//               <Typography fontWeight="bold">₹{Number(subtotal).toLocaleString("en-IN")}</Typography>
//             </Box>
//             <Box display="flex" justifyContent="space-between">
//               <Typography>GST ({formData.tax_rate}%):</Typography>
//               <Typography fontWeight="bold">₹{Number(tax).toLocaleString("en-IN")}</Typography>
//             </Box>
//             <Divider />
//             <Box display="flex" justifyContent="space-between">
//               <Typography variant="h6">Grand Total:</Typography>
//               <Typography variant="h5" color="primary" fontWeight="bold">
//                 ₹{Number(grand).toLocaleString("en-IN")}
//               </Typography>
//             </Box>
//           </Stack>
//         </Paper>

//         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 3, mb: 3 }}>
//           <TextField
//             label="Validity (Days)"
//             type="number"
//             value={formData.validity_days}
//             onChange={(e) => setFormData({ ...formData, validity_days: e.target.value })}
//           />
//           <TextField
//             label="Delivery Time (Days)"
//             type="number"
//             value={formData.delivery_days}
//             onChange={(e) => setFormData({ ...formData, delivery_days: e.target.value })}
//           />
//         </Box>

//         <TextField
//           label="Terms & Conditions"
//           multiline
//           rows={6}
//           fullWidth
//           value={formData.terms_conditions}
//           onChange={(e) => setFormData({ ...formData, terms_conditions: e.target.value })}
//           sx={{ mb: 3 }}
//         />

//         <Box sx={{ mb: 4 }}>
//           <Button variant="outlined" component="label" startIcon={<AttachFile />}>
//             Attach Files (BOQ, Design, Drawings, etc.)
//             <input type="file" hidden multiple onChange={handleAttachment} />
//           </Button>

//           <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 2 }}>
//             {attachments.map((file, i) => (
//               <Chip
//                 key={i}
//                 label={file.name}
//                 onDelete={() => removeAttachment(i)}
//                 color="primary"
//                 variant="outlined"
//               />
//             ))}
//           </Stack>
//         </Box>

//         <Box textAlign="center">
//           <Button
//             variant="contained"
//             size="large"
//             startIcon={saving ? <CircularProgress size={20} /> : <Save />}
//             onClick={handleSubmit}
//             disabled={saving}
//             sx={{ px: 8, py: 2, fontSize: "1.2rem" }}
//           >
//             {saving ? "Creating Quotation..." : "CREATE QUOTATION"}
//           </Button>
//         </Box>
//       </Paper>
//     </Box>
//   );
// }

// src/pages/Quotation/CreateQuotation.jsx

import React, { useState, useEffect } from "react";
import {
  Box, Paper, Typography, TextField, Button, IconButton,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Divider, Alert, CircularProgress, Chip, Stack
} from "@mui/material";
import { Add, Delete, AttachFile, Save, ArrowBack } from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function CreateQuotation() {
  const { id: leadId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [lead, setLead] = useState(null);
  const [success, setSuccess] = useState("");

  const [items, setItems] = useState([
    { item_name: "", description: "", qty: 1, unit: "Nos", rate: 0 }
  ]);

  const [formData, setFormData] = useState({
    validity_days: 15,
    delivery_days: 45,
    terms_conditions: `1. Prices are inclusive of GST @18%\n2. 50% Advance, 40% on material delivery, 10% on completion\n3. Validity: 15 days from date of quotation\n4. Delivery: 45 days from advance receipt`,
    tax_rate: 18,
  });

  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    if (leadId) fetchLead();
  }, [leadId]);

  const fetchLead = async () => {
    try {
      const res = await api.get(`/leads/${leadId}`);
      setLead(res.data.lead);
    } catch (err) {
      alert("Failed to load lead");
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  const addItem = () => setItems([...items, { item_name: "", description: "", qty: 1, unit: "Nos", rate: 0 }]);
  const removeItem = (i) => setItems(items.filter((_, idx) => idx !== i));

  const updateItem = (i, field, value) => {
    const updated = [...items];
    updated[i][field] = field === "qty" || field === "rate" ? parseFloat(value) || 0 : value;
    setItems(updated);
  };

  const handleAttachment = (e) => {
    setAttachments(prev => [...prev, ...Array.from(e.target.files)]);
  };

  const removeAttachment = (i) => {
    setAttachments(attachments.filter((_, idx) => idx !== i));
  };

  const calculateTotals = () => {
    const subtotal = items.reduce((sum, item) => sum + (item.qty || 0) * (item.rate || 0), 0);
    const tax = subtotal * (formData.tax_rate / 100);
    const grand = subtotal + tax;
    return { subtotal: subtotal.toFixed(2), tax: tax.toFixed(2), grand: grand.toFixed(2) };
  };

  const { subtotal, tax, grand } = calculateTotals();

  const handleSubmit = async () => {
    if (items.some(i => !i.item_name.trim() || i.rate <= 0)) {
      alert("Please fill all item names and valid rates");
      return;
    }

    setSaving(true);
    setSuccess("");

    const payload = new FormData();
    payload.append("lead_id", leadId);
    payload.append("items", JSON.stringify(items.map(i => ({
      item_name: i.item_name.trim(),
      description: i.description?.trim() || "",
      qty: Number(i.qty),
      unit: i.unit,
      rate: Number(i.rate)
    }))));
    payload.append("validity_days", formData.validity_days);
    payload.append("delivery_days", formData.delivery_days);  // ← FIXED: was append0
    payload.append("terms_conditions", formData.terms_conditions);
    payload.append("tax_rate", formData.tax_rate);

    attachments.forEach(file => payload.append("attachments", file));

    try {
      const res = await api.post("/quotations", payload);
      
      setSuccess(`Quotation ${res.data.quotation_no} created! ₹${Number(res.data.grand_total).toLocaleString("en-IN")}`);
      
      setTimeout(() => navigate("/quotations"), 2500);
    } catch (err) {
      alert("Error: " + (err.response?.data?.message || "Failed to create quotation"));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Box textAlign="center" mt={10}><CircularProgress /></Box>;

  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>Back</Button>

      <Paper elevation={6} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
          Create Quotation
        </Typography>

        <Box sx={{ bgcolor: "primary.light", color: "white", p: 3, borderRadius: 2, mb: 4 }}>
          <Typography variant="h6">{lead?.name} • {lead?.mobile}</Typography>
          <Typography>{lead?.company_name || "—"} • {lead?.lead_uid}</Typography>
        </Box>

        {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}

        <Typography variant="h6" fontWeight="bold" gutterBottom>Line Items</Typography>

        <TableContainer component={Paper} elevation={3} sx={{ mb: 4 }}>
          <Table>
            <TableHead sx={{ bgcolor: "grey.200" }}>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Item Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Rate (₹)</TableCell>
                <TableCell>Amount (₹)</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, i) => (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell><TextField size="small" fullWidth value={item.item_name} onChange={e => updateItem(i, "item_name", e.target.value)} /></TableCell>
                  <TableCell><TextField size="small" fullWidth value={item.description} onChange={e => updateItem(i, "description", e.target.value)} /></TableCell>
                  <TableCell><TextField size="small" type="number" sx={{ width: 80 }} value={item.qty} onChange={e => updateItem(i, "qty", e.target.value)} /></TableCell>
                  <TableCell><TextField size="small" sx={{ width: 80 }} value={item.unit} onChange={e => updateItem(i, "unit", e.target.value)} /></TableCell>
                  <TableCell><TextField size="small" type="number" sx={{ width: 120 }} value={item.rate} onChange={e => updateItem(i, "rate", e.target.value)} /></TableCell>
                  <TableCell><strong>₹{(item.qty * item.rate).toLocaleString("en-IN")}</strong></TableCell>
                  <TableCell><IconButton color="error" onClick={() => removeItem(i)}><Delete /></IconButton></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Button startIcon={<Add />} variant="outlined" onClick={addItem} sx={{ mb: 4 }}>Add Item</Button>

        <Paper elevation={4} sx={{ p: 3, maxWidth: 420, ml: "auto", mb: 4 }}>
          <Stack spacing={2}>
            <Box display="flex" justifyContent="space-between">
              <Typography>Subtotal:</Typography>
              <Typography fontWeight="bold">₹{Number(subtotal).toLocaleString("en-IN")}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography>GST ({formData.tax_rate}%):</Typography>
              <Typography fontWeight="bold">₹{Number(tax).toLocaleString("en-IN")}</Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h6">Grand Total:</Typography>
              <Typography variant="h5" color="primary" fontWeight="bold">
                ₹{Number(grand).toLocaleString("en-IN")}
              </Typography>
            </Box>
          </Stack>
        </Paper>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 3, mb: 3 }}>
          <TextField label="Validity (Days)" type="number" value={formData.validity_days} onChange={e => setFormData({ ...formData, validity_days: e.target.value })} />
          <TextField label="Delivery Time (Days)" type="number" value={formData.delivery_days} onChange={e => setFormData({ ...formData, delivery_days: e.target.value })} />
        </Box>

        <TextField
          label="Terms & Conditions"
          multiline rows={6} fullWidth
          value={formData.terms_conditions}
          onChange={e => setFormData({ ...formData, terms_conditions: e.target.value })}
          sx={{ mb: 3 }}
        />

        <Box sx={{ mb: 4 }}>
          <Button variant="outlined" component="label" startIcon={<AttachFile />}>
            Attach Files (BOQ, Design, etc.)
            <input type="file" hidden multiple onChange={handleAttachment} />
          </Button>
          <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 2 }}>
            {attachments.map((f, i) => (
              <Chip key={i} label={f.name} onDelete={() => removeAttachment(i)} color="primary" variant="outlined" />
            ))}
          </Stack>
        </Box>

        <Box textAlign="center">
          <Button
            variant="contained" size="large"
            startIcon={saving ? <CircularProgress size={20} /> : <Save />}
            onClick={handleSubmit} disabled={saving}
            sx={{ px: 8, py: 2, fontSize: "1.2rem" }}
          >
            {saving ? "Creating..." : "CREATE QUOTATION"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}